// Chakra imports
import { Box, Flex } from '@chakra-ui/react';
// Custom components
import DefaultAuth from 'layouts/auth/Default';
// Assets
import Footer from 'components/footer/FooterAuth';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import { getVariable } from 'whitelabel';
import LoginInputs from './LoginInputs';
import RecaptchaAlert from './RecaptchaAlert';

function SignIn() {
  return (
    <DefaultAuth
      illustrationBackground={getVariable('banner')}
      image={getVariable('banner')}
    >
      {typeof window !== 'undefined' && (
        <GoogleReCaptchaProvider
          siteKey={process.env.REACT_APP_RECAPTCHA}
          type="v3"
          scriptProps={{
            async: false, // optional, default to false,
            defer: false, // optional, default to false
            appendTo: 'body', // optional, default to "head", can be "head" or "body",
            nonce: undefined, // optional, default undefined
          }}
        >
          <Flex
            maxW={{ base: '100%', md: '40%' }}
            w="100%"
            mx={{ base: 'auto', lg: '0px' }}
            my={{ base: 'auto', lg: '150' }}
            me="auto"
            h="100%"
            alignItems="start"
            justifyContent="center"
            mb={{ base: '30px', md: '30px' }}
            px={{ base: '25px', md: '0px' }}
            mt={{ base: '0', md: '4vh' }}
            flexDirection="column"
          >
            <LoginInputs />
            <RecaptchaAlert />
            <Box mt={10}></Box>
            <Footer />
          </Flex>
        </GoogleReCaptchaProvider>
      )}
    </DefaultAuth>
  );
}

export default SignIn;
